import React from 'react';
import "./SmallBox.css"
import Icon from "../Icon/Icon";

const SmallBox = ({icon, primary, secondary, children}) => {

  let tema = '';
  if (primary) {
    tema = 'cyan';
  } else if (secondary) {
    tema = 'purple';
  }

  return (
      <div className="col-lg-3 col-xs-6">
        <div className={"small-box bg-" + tema}>
          <div className="inner">
            {children}
          </div>
          <div className="icon">
            <Icon icon={icon}/>
          </div>
        </div>
        {/*<a href="#" class="small-box-footer">More info <i class="fa fa-arrow-circle-right"></i></a>*/}
      </div>
  );
};

// Box.propTypes = {
//   title: PropTypes.string,
//   info: PropTypes.bool
// };

export default SmallBox;


// WEBPACK FOOTER //
// ./src/component/Box/SmallBox.js